export const TOTAL_SECONDS = 30

export const BRAND = 'SOLVENTUM'

export const BRAND_LOGO =
  'https://cdn.magicpatterns.com/uploads/jQTf4HGK9DcziiSEJLi9E6/solventum-logo-horz-clr-rev-cmyk.png'

export interface Clip {
  /** Optional real clinical footage. When present it plays instead of the frame sequence. */
  video?: string
  /** Frames played as a short 2–4s loop when no video source is supplied. */
  frames: string[]
  alt: string
}

/** Page 3 — one still close-up of a conventionally bonded attachment with excess composite. */
export const problemClip: Clip = {
  frames: [
    'https://cdn.magicpatterns.com/patterns/generated-images/e88037e1-33db-49c4-bbfb-4b9662b9da38.jpg',
  ],
  alt: 'Close-up of a conventionally created composite attachment with excess material at the margin',
}

/** Page 4 — digital plan becoming a pre-formed attachment, seated and bonded. */
export const solutionClip: Clip = {
  frames: [
    'https://cdn.magicpatterns.com/patterns/generated-images/6f8b53ac-7d8d-4867-843c-f304efabc90e.jpg',
    'https://cdn.magicpatterns.com/patterns/generated-images/e604c62e-6b59-4547-9e01-43158c70bd19.jpg',
    'https://cdn.magicpatterns.com/patterns/generated-images/f1eee7cb-0c20-4a8c-8c14-889120f3507f.jpg',
    'https://cdn.magicpatterns.com/patterns/generated-images/568a8741-7403-49dd-a88f-97327cca1279.jpg',
    'https://cdn.magicpatterns.com/patterns/generated-images/0ae5046c-50de-40e9-8d42-ad69a79186ea.jpg',
  ],
  alt: 'The digital plan becoming a pre-formed Precision Grip attachment, pre-loaded in the transfer tray and bonded',
}

export interface Defect {
  name: string
  body: string
  image: string
}

export const defects: Defect[] = [
  {
    name: 'Shape',
    body: 'The bonded attachment may not reproduce the planned geometry exactly. Overfill, underfill or distortion can change the surface the aligner engages with.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7cd350d7-6529-43e7-ae4f-aa5f5f174ad6.jpg',
  },
  {
    name: 'Position',
    body: 'The attachment can be correctly shaped but still bonded off-plan. A location difference may change where the aligner applies force.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/38bbd729-2284-4a08-b03b-532417a7cbd3.jpg',
  },
  {
    name: 'Flash',
    body: 'Excess composite can remain around the attachment edge. This can affect attachment position and alter the intended force vector.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e88037e1-33db-49c4-bbfb-4b9662b9da38.jpg',
  },
]

export interface Solution {
  name: string
  cardHeadline: string
  body: string
  before: string
  beforeLabel: string
  after: string
  afterLabel: string
  /** Drop the "before" panel once the transformation has landed. */
  dropBefore?: boolean
}

export const solutions: Solution[] = [
  {
    name: 'Shape',
    cardHeadline: 'Made to the digital design',
    body: 'Precision Grip is pre-formed and 3D printed to the planned attachment geometry.',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/6f8b53ac-7d8d-4867-843c-f304efabc90e.jpg',
    beforeLabel: 'Digital design',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/e604c62e-6b59-4547-9e01-43158c70bd19.jpg',
    afterLabel: 'Pre-formed',
  },
  {
    name: 'Position',
    cardHeadline: 'Placed through the transfer tray',
    body: 'The attachment arrives pre-loaded in the tray for transfer to the planned location.',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/f1eee7cb-0c20-4a8c-8c14-889120f3507f.jpg',
    beforeLabel: 'Pre-loaded tray',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/568a8741-7403-49dd-a88f-97327cca1279.jpg',
    afterLabel: 'Seated on the tooth',
  },
  {
    name: 'Flash',
    cardHeadline: 'No composite flash',
    body: 'Because the attachment is already formed, there is no excess composite around the attachment perimeter from manually filling the attachment well.',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/e88037e1-33db-49c4-bbfb-4b9662b9da38.jpg',
    beforeLabel: 'Conventional',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/0ae5046c-50de-40e9-8d42-ad69a79186ea.jpg',
    afterLabel: 'Precision Grip',
    dropBefore: true,
  },
]

export const accumulation = [
  { cases: '1 case', gain: '12 min' },
  { cases: '3 cases', gain: '36 min' },
  { cases: '5 cases', gain: '60 min' },
]

export const questionOptions = ['Yes', 'Not always']
